import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGeocachingComponent } from './simple-icons-geocaching.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGeocachingComponent ],
    exports:      [ SimpleIconsGeocachingComponent ],
    bootstrap:    []
})
export class SimpleIconsGeocachingModule {}
